export default "__VITE_ASSET__C5kbX468__"